import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import './index.css';
import './shared/i18n';
import { AuthProvider, supabaseAuthRepository } from '@features/auth';
import { queryClient } from '@shared/lib/query-client';
import { applyTheme, getInitialTheme } from '@shared/lib/theme';
import { router } from './app/router';
import { startSyncBootstrap } from './app/sync-bootstrap';

// Re-apply the theme post-hydration to cover the case where the inline
// pre-hydration script in index.html was skipped (e.g. CSP blocked, or the
// tab was restored from BFCache after a system-theme toggle). The hook
// itself is idempotent so duplicate work is cheap.
applyTheme(getInitialTheme());
startSyncBootstrap();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider repository={supabaseAuthRepository}>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
